import { useCallback, useEffect, useRef } from 'react';
import SubmittedEmailTable from '../../../components/SubmittedEmailTable';
import EmailManagerTopBar from '../../../components/EmailManagerTopBar';
import { useSubmittedEmailsContext } from '../../../contexts/SubmittedEmailsContext';
import useResponsive from '../../../hooks/useResponsive';

const EmailManagerPage = () => {
  const { isDesktop } = useResponsive();
  const { loadSubmittedEmails } = useSubmittedEmailsContext();
  const exportCsvRef = useRef<(() => void) | null>(null);

  const handleExportReady = useCallback((exportCsv: () => void) => {
    exportCsvRef.current = exportCsv;
  }, []);

  const handleDownloadCsv = useCallback(() => {
    exportCsvRef.current?.();
  }, []);

  useEffect(() => {
    // only want to load the restaurants user emails if manager page is being utilized
    // call to load those announcements on initial load
    loadSubmittedEmails();
  }, [loadSubmittedEmails]);

  return (
    <div className="email-manager-page-container">
      <EmailManagerTopBar onDownloadCsv={handleDownloadCsv} />
      <SubmittedEmailTable isDesktop={isDesktop} onExportReady={handleExportReady} />
    </div>
  );
};

export default EmailManagerPage;
